import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
@Injectable({
  providedIn: 'root'
})
export class EcommerceService {
  constructor(private http: HttpClient) {}
  addToCartData = [];
  cartDatas = [];
  productCart : any = [];
  sendData = [];

  getData() {
   // return this.http.get("https://run.mocky.io/v3/0f1ec3d0-7658-4f35-8ac8-74c36ab93ddd");
   //  return this.http.get("https://run.mocky.io/v3/3093c28c-f43a-4313-916f-56c3236f6cfb");
   return this.http.get("https://run.mocky.io/v3/4b6193ae-0c4a-46b5-a088-9bb82aec1ef7");
  }

  addToCart(val: any) {
    this.productCart = JSON.parse(localStorage.getItem('cardData'))!= null ? JSON.parse(localStorage.getItem('cardData')) : [];
    for (var i = 0; i < this.productCart.length; i++) {
      if (val.id == this.productCart[i].id) {
        alert("Already Cart");
        return this.productCart.length;
      }
    }
    this.productCart.push(val);
    localStorage.setItem('cardData', JSON.stringify(this.productCart));
    console.log("cart Length",this.productCart.length);
    return this.productCart.length;
  }

  showToCard() {
    let cardData = [];
    if (this.productCart.length > 0) {
      cardData = this.productCart;
    } else {
      cardData = JSON.parse(localStorage.getItem('cardData'));
    }
    return this.sendData = cardData != null ? cardData : [];
  }

}

function res(res: any): import("rxjs").OperatorFunction<Object, unknown> {
  throw new Error("Function not implemented.");
}
